import * as branchProduct from "../slices/branchProduct.slice";
import { ENDPOINT } from "../../constants/api";
import { fetchApiData } from "../../utils/apiUtils";

export const getBranchProduct =
  (businessSlug, id, branchId) => async (dispatch) => {
    console.log("businessSlug : ", businessSlug);
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS_BRANCH_PRODUCT.replace(
        "{businessSlug}",
        businessSlug
      )}/${id}`,
      dispatch,
      params: {
        branchId: branchId,
      },
    });
    if (data) {
      dispatch(branchProduct.clearData());
      dispatch(branchProduct.setData(data));
    }
  };
